import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const AnnouncementBar = () => {
  const [a, setA] = useState(null);
  useEffect(() => { api.get("/announcement").then((r) => setA(r.data)).catch(() => {}); }, []);
  if (!a || !a.enabled) return null;
  const text = a.text || "Discover Timeless Elegance";
  const items = Array(6).fill(text);
  return (
    <div
      data-testid="announcement-bar"
      className="bg-[#0d0b09] border-b border-[#D4AF37]/15 py-2 overflow-hidden"
    >
      <div className="marquee text-[11px] tracking-[0.32em] uppercase text-[#D4AF37]/90">
        {items.concat(items).map((t, i) => (
          <span key={i} className="mx-8 shrink-0 flex items-center gap-8">
            {t}
            <span className="text-[#D4AF37]/40">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
